import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import Lmsmarketplace from "../component/lmsMarketPlace/lmsMarketPlace.jsx";
import LmsHeader from "../component/lmsHeader/lmsHeader.jsx";
import Loader from "../../../library/common/Loader.jsx";

import * as lmsUserAction from "../../../redux/actions/lmsUserAction";
import * as lmsAction from "../../../redux/actions/lmsAction";
import { API_STATUS, ORG_ID, USER_ID } from "../../../constant/constant.js";
import { InactiveClient } from "../../../utils/helper.js";
import { ACCESS_DENIED } from "../../../constant/routeContant.js";
import { checkPrivileges } from "../../../utils/rolesHelper";

const PAGE_SIZE = 6;

const LmsmarketplaceContainer = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const isLoading = useSelector((state) => state.getUserCoursesList?.isLoading);
  const coursesData = useSelector((state) => state.getUserCoursesList?.data);
  const launchUrlData = useSelector((state) => state.buildscormLaunch);
  const completeCourse = useSelector((state) => state.completeCourse);
  const categoryListData = useSelector((state) => state.getCategoryList?.data);
  const coursesUserListData = useSelector((state) => state.getUserCoursesList);
  const showStartLoader = useSelector(
    (state) => state.startCourse?.isLoading || state.getCategoryList?.isLoading
  );
  let navigate = useNavigate();

  const defaultParams = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    catIds: "",
    statusId: 2,
    userId: USER_ID(),
    orgId: ORG_ID(),
    isSendMail: false,
    isScorm: true,
  };

  const getCoursesUserListData = (data) => {
    dispatch(lmsUserAction.getUserCoursesList(data));
    // dispatch(lmsUserAction.getUserCoursesListFilterObj(data));
  };

  // User clicked "Start"
  const handleViewOnClick = useCallback(
    async (courseId, statusId) => {
      if (InactiveClient()) return;
      if (parseInt(statusId) !== 1) {
        const data = {
          courseId: Number(courseId),
          userId: Number(USER_ID()),
          orgId: Number(ORG_ID()),
        };

        await dispatch(lmsUserAction.startCourse(data));
        await dispatch(lmsAction.getScormLauchLinkApi(data));
      }
    },
    [dispatch]
  );

  // When launch URL arrives → OPEN NEW TAB
  useEffect(() => {
    if (launchUrlData?.status === API_STATUS.SUCCESS) {
      const url = launchUrlData?.data?.result;
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    }
  }, [launchUrlData]);

  // After SCORM completes → refresh course list
  const defaultParamsCompleted = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    catIds: "",
    statusId: 1,
    userId: USER_ID(),
    orgId: ORG_ID(),
    isSendMail: false,
    isScorm: true,
  };
  useEffect(() => {
    if (completeCourse?.status === API_STATUS.SUCCESS) {
      getCoursesUserListData(defaultParamsCompleted);
    }
  }, [completeCourse]);

  // Certus returns: domain.com/lms-market-place?courseid=123

  useEffect(() => {
    const courseId = searchParams.get("courseid");
    if (courseId) {
      dispatch(
        lmsAction.completeCourse({
          courseId: Number(courseId),
          userId: Number(USER_ID()),
          orgId: Number(ORG_ID()),
        })
      );
    }
  }, [searchParams]);

  const headerData = {
    title: "Learning Marketplace",
    helpText:
      "Access and enroll in a wide range of training courses from our trusted third-party partners.",
    menu: [],
  };
  const getategoryListData = (data) => {
    dispatch(lmsAction.getCategoryList(data));
  };
  useEffect(() => {
    const isAllowedDash = checkPrivileges([12, 11, 10, 9]);

    if (isAllowedDash === false) {
      navigate(ACCESS_DENIED);
    }
    getCoursesUserListData(
      coursesUserListData?.filterObj
        ? coursesUserListData.filterObj
        : defaultParams
    );
    dispatch(lmsAction.clearCategoryList());
  }, []);
  useEffect(() => {
    getCoursesUserListData(defaultParams);
  }, [dispatch]);
  return (
    <>
      {showStartLoader && <Loader />}
      <LmsHeader dataHeader={headerData} />

      <Lmsmarketplace
        coursesUserList={coursesData}
        handleViewOnClick={handleViewOnClick}
        isLoading={isLoading}
        getCoursesUserListData={getCoursesUserListData}
        categoryUserListData={categoryListData}
        getategoryListData={getategoryListData}
        coursesUserListDatas={coursesUserListData}
        searchParams={searchParams}
      />
    </>
  );
};

export default LmsmarketplaceContainer;
